var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPresentAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.4375C14.1217 20.4375 16.1566 19.5946 17.6569 18.0944C19.1571 16.5941 20 14.5592 20 12.4375C20 10.3158 19.1571 8.28094 17.6569 6.78065C16.1566 5.28035 14.1217 4.4375 12 4.4375C9.87827 4.4375 7.84344 5.28035 6.34315 6.78065C4.84285 8.28094 4 10.3158 4 12.4375C4 14.5592 4.84285 16.5941 6.34315 18.0944C7.84344 19.5946 9.87827 20.4375 12 20.4375V20.4375ZM11.555 9.6055C11.4044 9.50502 11.2293 9.44731 11.0485 9.43853C10.8677 9.42974 10.6879 9.47022 10.5282 9.55563C10.3686 9.64104 10.2352 9.76818 10.1421 9.92349C10.0491 10.0788 9.99997 10.2565 10 10.4375V14.4375C9.99997 14.6185 10.0491 14.7962 10.1421 14.9515C10.2352 15.1068 10.3686 15.234 10.5282 15.3194C10.6879 15.4048 10.8677 15.4453 11.0485 15.4365C11.2293 15.4277 11.4044 15.37 11.555 15.2695L14.555 13.2695C14.692 13.1782 14.8043 13.0545 14.8819 12.9093C14.9596 12.7642 15.0002 12.6021 15.0002 12.4375C15.0002 12.2729 14.9596 12.1108 14.8819 11.9657C14.8043 11.8205 14.692 11.6968 14.555 11.6055L11.555 9.6055V9.6055Z",
    fill: "#868C9F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentAction);
export default __webpack_public_path__ + "static/media/presentAction.fe48ef08c6bdcc477a6e7907d1e1fc39.svg";
export { ForwardRef as ReactComponent };